export default {
    finalize() {
        console.log("Toggle-framework finalize");

        let $body = $("body");

        $body.on("click", "[data-toggle]", function () {
            let selector = $(this).data("toggle");

            let search = $(this).data("search") || "find";
            let $element;
            switch (search) {
                case "closest": {
                    $element = $(this).closest(selector);
                    break;
                }

                case "find":
                default: {
                    $element = $body.find(selector);
                    break;
                }
            }

            let classToAdd = $(this).data("toggle-class") || "toggle";
            $element.toggleClass(classToAdd);
            console.log("toggle", selector, $element);
        });
    },
};


// WEBPACK FOOTER //
// ./scripts/util/toggleFramework.js